import axios from 'axios';
import snackBarService from '@/shared/snackbar/snackbar.service';
import DirectiveDefinition from './directive-definition.entity';
import ProjectDirectives from './project-directives.entity';

export default class DirectivesService {
  static getDefaultDirectives() {
    return axios
      .get('/workitems/directives')
      .then((response: any) => DirectiveDefinition.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getAllWorkItemTypesDirectives(projectId?: string) {
    return axios
      .get(`/workitems/projects/${projectId}/directives/all-workitem-types`)
      .then((response: any) => DirectiveDefinition.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getProjectCoreIdMapper(projectId: string) {
    return axios
      .get(`/mapper/configuration/v2/byProject/${projectId}`)
      .then((response: any) => response.data)
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getProjectDirectivesMapper(projectMapperId: string) {
    return axios
      .get(`/mapper/configuration/v2/${projectMapperId}`)
      .then((response: any) => response.data)
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getProjectDirectives(projectId?: string) {
    return axios
      .get(`/workitems/projects/${projectId}/directives`)
      .then((response: any) => ProjectDirectives.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static updateAllWorkItemTypes(projectId?: string, directive?: any) {
    return axios
      .put(`/workitems/projects/${projectId}/directives/all-workitem-types`, directive)
      .then((response: any) => ProjectDirectives.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static updateProjectDirective(directiveId?: any, directivePersist?: any) {
    return axios
      .put(`/workitems/directives/definitions/${directiveId}`, directivePersist)
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
